import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next/';
import { Card, CardBody } from 'reactstrap';
import Panel from '../../../shared/components/Panel';
import ClassEngagementChart from './ClassEngagementChart';
import { findEngagementMetrics } from '../../../shared/queries/Dashboard';
import GraphQL from '../../../GraphQL';

const EngagementBoard = (props) => {
  const { t } = props;

  const [numbersChart, setNumbersChart] = useState([]);

  const dataLabels = [
    t('dashboard.engagementBoard.classEngagement.never'),
    t('dashboard.engagementBoard.classEngagement.nothing'),
    t('dashboard.engagementBoard.classEngagement.little'),
    t('dashboard.engagementBoard.classEngagement.medium'),
    t('dashboard.engagementBoard.classEngagement.engaged'),
  ];

  const options = {
    plugins: {
      datalabels: false,
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  const loadData = () => {
    const query = findEngagementMetrics();
    GraphQL(query, {})
      .then((res) => {
        if (res.findEngagementMetrics) {
          const updatedNumbersChart = [];
          updatedNumbersChart.push(res.findEngagementMetrics.never);
          updatedNumbersChart.push(res.findEngagementMetrics.nothing);
          updatedNumbersChart.push(res.findEngagementMetrics.low);
          updatedNumbersChart.push(res.findEngagementMetrics.medium);
          updatedNumbersChart.push(res.findEngagementMetrics.high);
          setNumbersChart(updatedNumbersChart);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <h2 className="dashboard-titles">
        {t('dashboard.engagementBoard.title')}
      </h2>

      <div className="row">
        <div className="col-6">
          <Card>
            <CardBody className="card-account-actives">
              <Panel
                title={t('dashboard.engagementBoard.classEngagement.title')}
                className="pb-0"
              >
                <div className="row">
                  <Card className="pb-0">
                    <CardBody className="pb-0">
                      <ClassEngagementChart
                        numbersChart={numbersChart}
                        dataLabels={dataLabels}
                        options={options}
                      />
                    </CardBody>
                  </Card>
                </div>
              </Panel>
            </CardBody>
          </Card>
        </div>
      </div>
    </Fragment>
  );
};

EngagementBoard.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(EngagementBoard);
